import { render } from "./createForm.vue?vue&type=template&id=8cb742d2&scoped=true"
import script from "./createForm.js?vue&type=script&lang=js"
export * from "./createForm.js?vue&type=script&lang=js"

import "./createForm.vue?vue&type=style&index=0&id=8cb742d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cb742d2"]])

export default __exports__